/**
 * TC39 DisposeResources: every step runs even after one fails; each later failure wraps the earlier ones as
 * `new SuppressedError(later, earlier, message)`, so the chain keeps every failure in disposal order.
 */
export async function disposeAll(steps: (() => unknown)[], message: string): Promise<void> {
  let failed = false
  let failure: unknown
  for (const step of steps) {
    try { await step() }
    catch (error) {
      failure = failed ? new SuppressedError(error, failure, message) : error
      failed = true
    }
  }
  if (failed) throw failure
}
